const LEAD_DATA_KEY = "leadData";

export const getLeadData = (): Record<string, any> => {
  if (typeof window === "undefined") return {};
  
  try {
    // Try sessionStorage first
    const sessionData = sessionStorage?.getItem(LEAD_DATA_KEY);
    if (sessionData) {
      return JSON.parse(sessionData);
    }
    
    // Fallback to localStorage
    const localData = localStorage?.getItem(LEAD_DATA_KEY);
    if (localData) {
      return JSON.parse(localData);
    }
    
    // Last fallback: try to get phone number from sessionStorage
    const contactNumber = sessionStorage?.getItem("contact_number");
    if (contactNumber) {
      return { phone: contactNumber };
    }
    
    return {};
  } catch (error) {
    return {};
  }
};

export const setLeadData = (data: Record<string, any>): void => {
  if (typeof window === "undefined") return;
  
  try {
    const jsonString = JSON.stringify(data);
    sessionStorage.setItem(LEAD_DATA_KEY, jsonString);
    localStorage.setItem(LEAD_DATA_KEY, jsonString);
  } catch (error) {
    console.error("Error saving lead data:", error);
  }
};

export const clearLeadData = (): void => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    localStorage.removeItem(LEAD_DATA_KEY);
  }
};

